import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import JobRow from 'components/modules/shipments/tracking/DriverJobRow';
import { JOB_CANCELED, JOB_CLOSED } from 'constants/JobStatus';

import Spinner from '../../../ui/Spinner';

class DriverJobsPopover extends Component {
  static propTypes = {
    driver: PropTypes.shape({
      fullName: PropTypes.string,
      phone: PropTypes.string,
    }).isRequired,
    jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onOpenShipment: PropTypes.func.isRequired,
    hasActiveJobs: PropTypes.bool,
  };

  renderHeader = () => {
    const { t } = this.props;
    if (!this.props.hasActiveJobs && !this.props.jobs.length) {
      return (
        <tr style={{ textAlign: 'center', paddingTop: '4px' }}>
          <td>
            <p className="pt-2">{t('NO_ACTIVE_JOBS')}</p>
          </td>
        </tr>
      );
    }
    if (
      this.props.jobs &&
      this.props.jobs.length &&
      _.isObject(this.props.jobs[0])
    ) {
      return (
        <tr>
          <th>{titleize(t('SHIPMENT'))}</th>
          <th>{titleize(t('ORIGIN'))}</th>
          <th>{titleize(t('DESTINATION'))}</th>
          <th>{t('STATUS')}</th>
        </tr>
      );
    }
    return (
      <tr
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}
      >
        <td>
          <div className="flex mx-auto pt-2">
            <Spinner
              showMessage
              message={t('LOADING_JOBS')}
              style={{ color: '#21b88e' }}
            />
          </div>
        </td>
      </tr>
    );
  };

  render() {
    const {
      driver: { fullName, phone },
      t,
    } = this.props;
    const viewableJobs = this.props.jobs.filter((job) => {
      if (
        job.current_status === JOB_CANCELED ||
        job.current_status === JOB_CLOSED
      ) {
        return false;
      }
      return true;
    });
    const phoneLink = `tel: ${phone}`;
    return (
      <div className="driver-jobs-popover">
        <h5 className="title">{t('JOBS_FOR_NAME', { name: fullName })}</h5>
        {phone && (
          <span className="phone">
            <i className="fa fa-phone" />
            <a href={phoneLink}>{phone}</a>
          </span>
        )}
        <div className="content">
          <Table striped condensed>
            <thead>{this.renderHeader()}</thead>
            <tbody>
              {viewableJobs.map((job, index) => (
                <JobRow
                  job={job}
                  key={index}
                  onOpenShipment={this.props.onOpenShipment}
                />
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DriverJobsPopover);
